import { PROGRAM_SECTIONS,SETTINGS_GROUPS } from '@ekhodealer/ekho-common';

import { ParentSection } from '../../config-mgmt/ParentSection';

import { CheckoutAssignmentForm } from './checkout-forms/CheckoutAssignmentForm';
import { CheckoutDisclosuresForm } from './checkout-forms/CheckoutDisclosuresForm';
import { CheckoutFulfillmentForm } from './checkout-forms/CheckoutFulfillmentForm';
import { CheckoutPaymentForm } from './checkout-forms/CheckoutPaymentForm';
import { CheckoutStatesSupportedForm } from './checkout-forms/CheckoutStatesSupportedForm';

export function ProgramOwnerCheckoutSection() {
	return (
		<ParentSection
			title='Checkout'
			sectionPath={{
				group: SETTINGS_GROUPS.PROGRAM,
				section: PROGRAM_SECTIONS.CHECKOUT,
			}}>
			<CheckoutAssignmentForm />
			<CheckoutFulfillmentForm />
			<CheckoutPaymentForm />
			<CheckoutStatesSupportedForm />
			<CheckoutDisclosuresForm />
		</ParentSection>
	);
}

export default ProgramOwnerCheckoutSection;
